export const APP_HOSTED_URL = window.location.origin
export const APP_HOST_NAME = window.location.hostname
export const API_BASE_URL = `${APP_HOSTED_URL}/api/request`

export const teamConditionalQuestions = teams => [
  {
    id: 12345678910,
    isMandatory: true,
    order: 1,
    text: 'Register or Join a Team',
    options: [
      {
        label: 'Join a Team',
        value: 'Join A Team',
      },
      {
        label: 'Register a Team',
        value: 'Register A Team',
      },
    ],
    relatedQuestion: {
      sfid: 'registerOrJoinATeam',
      name: 'Register or Join A Team',
      type: 'Toggle',
      text: 'Register or Join A Team',
      defaultValue: 'Join A Team',
      isTeamQuestion: true,
      isSportsTGQuestion: true,
    },
    isLocked: false,
    dependentQuestions: [],
    isTeamQuestion: true,
  },
  {
    id: 12345678911,
    isMandatory: false,
    order: 2,
    text: 'Register A Team',
    style: true,
    relatedQuestion: {
      type: 'Header Text',
      sfid: 'registerATeamHeading',
      text: 'Register A Team',
      isTeamQuestion: true,
      isSportsTGQuestion: true,
    },
    dependentQuestions: [
      {
        primaryQuestionAnswer: 'Register A Team',
        primaryQuestionId: 'registerOrJoinATeam',
        primaryQuestionType: 'Toggle',
      },
    ],
  },
  {
    id: 12345678912,
    isMandatory: true,
    order: 3,
    text: 'New or Existing Team',
    options: [
      {
        label: 'Select Existing Team',
        value: 'Select Existing Team',
      },
      {
        label: 'Create New',
        value: 'Create New',
      },
    ],
    relatedQuestion: {
      sfid: 'newOrExistingTeam',
      name: 'New or Existing Team',
      type: 'Toggle',
      text: 'New or Existing Team',
      defaultValue: 'Select Existing Team',
      isTeamQuestion: true,
      isSportsTGQuestion: true,
    },
    isLocked: false,
    dependentQuestions: [
      {
        primaryQuestionAnswer: 'Register A Team',
        primaryQuestionId: 'registerOrJoinATeam',
        primaryQuestionType: 'Toggle',
      },
    ],
    isTeamQuestion: true,
  },
  {
    id: 12345678913,
    isMandatory: true,
    order: 4,
    text: 'Select Existing Team',
    options: teams,
    relatedQuestion: {
      sfid: 'selectTeam',
      name: 'Select Existing Team',
      type: 'DropDown',
      text: 'Select Existing Team',
      defaultValue: {},
      isTeamQuestion: true,
      isSportsTGQuestion: true,
    },
    isLocked: false,
    dependentQuestions: [
      {
        primaryQuestionAnswer: 'Select Existing Team',
        primaryQuestionId: 'newOrExistingTeam',
        primaryQuestionType: 'Toggle',
      },
      {
        primaryQuestionAnswer: 'Register A Team',
        primaryQuestionId: 'registerOrJoinATeam',
        primaryQuestionType: 'Toggle',
      },
    ],
    isTeamQuestion: true,
  },
  {
    id: 12345678914,
    isMandatory: false,
    order: 5,
    text: 'Enter Team Code',
    style: true,
    relatedQuestion: {
      type: 'Header Text',
      sfid: 'enterTeamCodeHeading',
      text: 'Enter Team Code',
      isTeamQuestion: true,
      isSportsTGQuestion: true,
    },
    dependentQuestions: [
      {
        primaryQuestionAnswer: 'Join A Team',
        primaryQuestionId: 'registerOrJoinATeam',
        primaryQuestionType: 'Toggle',
      },
    ],
  },
  {
    id: 12345678915,
    isMandatory: true,
    order: 5,
    text: 'Input Team Code',
    relatedQuestion: {
      type: 'Search',
      sfid: 'inputTeamCode',
      text: 'Input Team Code',
      name: 'Input Team Code',
      isTeamQuestion: true,
      isSportsTGQuestion: true,
    },
    dependentQuestions: [
      {
        primaryQuestionAnswer: 'Join A Team',
        primaryQuestionId: 'registerOrJoinATeam',
        primaryQuestionType: 'Toggle',
      },
    ],
  },
]
